// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProductCategoriesData, ProductCategoriesPayload } from "@conklin/App/Services/ProductCategories";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<ProductCategoriesPayload, CategoryModel[]>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SetLoading: HandlerType = props => {
    props.dispatch({
        type: "xProductCategories/startLoading",
        key: getDataViewKey(props.apiParameter),
    } as any);
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getProductCategoriesData(props.apiParameter);
    } catch (error) {
        logger.error(error);
    }
};

export const DispatchCompleteLoadProductCategoriesData: HandlerType = props => {
    props.dispatch({
        type: "xProductCategories/updateCategories",
        categories: props.apiResult,
        key: getDataViewKey(props.parameter),
    } as any);
};

export const ClearLoading: HandlerType = props => {
    props.dispatch({
        type: "xProductCategories/CompleteLoading",
        key: getDataViewKey(props.parameter),
    } as any);
};

export const chain = [
    PopulateApiParameters,
    SetLoading,
    RequestDataFromApi,
    DispatchCompleteLoadProductCategoriesData,
    ClearLoading,
];

const loadProductCategories = createHandlerChainRunner(chain, "loadProductCategories");

export default loadProductCategories;
